import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../assets/styles/media';
import THEME from '../../assets/styles/config';

interface DropdownProps {
  open?: boolean;
}

// The menu is positioned against this, so it lines up with the button and never runs off the page's edge.
export const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownBtn = styled.button<DropdownProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #d5dbe1;
  border-radius: 12px;
  background: white;
  color: ${THEME.colors.primaryFontColor};
  font-family: inherit;
  font-weight: bold;
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    border-color: ${THEME.colors.primaryColor};
  }

  &:focus-visible {
    outline: none;
    border-color: ${THEME.colors.primaryColor};
    box-shadow: 0 0 0 3px rgba(62, 160, 205, 0.25);
  }

  ${Media.Below.tablet`
    font-size: 14px;
  `}

  ${Media.Below.mobileLarge`
    font-size: 13px;
  `}

  > img,
  > svg {
    flex: 0 0 auto;
    transition: transform 0.2s ease-in-out;

    ${(props): SimpleInterpolation =>
      props.open &&
      css`
        transform: rotate(180deg);
      `}
  }
`;

export const DropdownDraw = styled.div<DropdownProps>`
  display: none;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  min-width: 100%;
  margin-top: 6px;
  padding: 4px;
  box-sizing: border-box;
  border: 1px solid #e3e8ed;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 8px 24px rgba(20, 35, 50, 0.14);
  font-weight: bold;
  font-size: 15px;
  z-index: 20;

  ${(props): SimpleInterpolation =>
    props.open &&
    css`
      display: flex;
    `}
`;

interface DropdownOptionProps {
  active?: boolean;
}

export const DropdownOption = styled.button<DropdownOptionProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: ${THEME.colors.primaryFontColor};
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    outline: none;
    background: #f1f5f8;
  }

  ${(props): SimpleInterpolation =>
    props.active &&
    css`
      color: ${THEME.colors.primaryColor};

      &::after {
        content: '\\2713';
        font-size: 13px;
      }
    `}
`;

export const DropdownCtn = styled.div`
  display: flex;
  justify-content: space-between;
`;
